module.exports = __webpack_public_path__ + "static/media/img_33.87302314.png";